import React from 'react'
import { Button, Stack } from '@mui/material'
import { useTranslation } from '../../common/hooks/helper/useTranslation'
import { localStorageKey } from '../../utils/localStorageKey'

interface PrivacyStatementButtonsProps {
  onClose: () => void
}
export const PrivacyStatementButtons: React.FC<
  PrivacyStatementButtonsProps
> = ({ onClose }) => {
  const { t } = useTranslation()

  const handleCloseByButton = (accepted: boolean) => {
    localStorage.setItem(
      localStorageKey.privacyStatement,
      JSON.stringify(accepted)
    )
    onClose()
  }

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="flex-end"
      spacing={2}
    >
      <Button variant="outlined" onClick={() => handleCloseByButton(false)}>
        {t('common:reject')}
      </Button>
      <Button color="primary" onClick={() => handleCloseByButton(true)}>
        {t('common:accept')}
      </Button>
    </Stack>
  )
}
